export * from './groupings';
export var AccountCardType;
(function (AccountCardType) {
    AccountCardType["ACCOUNT"] = "ACCOUNT";
    AccountCardType["CREDIT_CARD"] = "CREDIT_CARD";
    AccountCardType["HOLDING_ACCOUNT"] = "HOLDING_ACCOUNT";
})(AccountCardType || (AccountCardType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kZWxzL2FjY291bnQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsY0FBYyxhQUFhLENBQUM7QUFFNUIsTUFBTSxDQUFOLElBQVksZUFJWDtBQUpELFdBQVksZUFBZTtJQUN2QixzQ0FBbUIsQ0FBQTtJQUNuQiw4Q0FBMkIsQ0FBQTtJQUMzQixzREFBbUMsQ0FBQTtBQUN2QyxDQUFDLEVBSlcsZUFBZSxLQUFmLGVBQWUsUUFJMUIifQ==